import { get, ref } from 'firebase/database';
import { doc, getDoc } from 'firebase/firestore';

import { NotebookDataType } from 'shared/types/notebookTypes';

import { database, firestore } from '../Common/Firebase';

export const getNotebookDataBySheetId = async (
  userMail: string | undefined,
  userSubject: string | undefined,
  id: string,
) => {
  if (userMail && userSubject) {
    const docRef = doc(firestore, 'notebook-content', userMail);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return get(ref(database, `Notebooks/${userMail}/${userSubject}/${id}`)).then(response => {
        const data = response.val();

        const newSheet: NotebookDataType = {
          id: data.id,
          isSquared: data.isSquared,
          firstContent: {
            content: docSnap.data()[userSubject][id].firstContent,
            isReviewed: data.firstSheet.isReviewed,
            lastModifiedDate: data.firstSheet.lastModifiedDate,
            order: data.firstSheet.order,
            homework: data.firstSheet.homework,
          },
          secondContent: {
            content: docSnap.data()[userSubject][id].secondContent,
            isReviewed: data.secondSheet.isReviewed,
            lastModifiedDate: data.secondSheet.lastModifiedDate,
            order: data.secondSheet.order,
            homework: data.secondSheet.homework,
          },
          nextId: data.nextId,
          prevId: data.prevId,
          spreadOrder: data.spreadOrder,
        };

        return newSheet;
      });
    } else {
      console.log('No such document!');
    }
  }
};
